import React from "react"
import HeroSectionEn from "./components/HeroSectionEn"
import HeroSectionKo from "./components/HeroSectionKo"
import { Locale } from "../../locale"

export default function HeroSectionRoute() {
  const { lang } = Locale.getDefault()

  if (lang === "ko") {
    return <HeroSectionKo />
  }

  return <HeroSectionEn />
}
